





























































import type { PropType } from '@nuxtjs/composition-api';
import { computed, defineComponent } from '@nuxtjs/composition-api';
import { SfLink } from '@storefront-ui/vue';

import VaimoSlider from '~/diptyqueTheme/components/molecules/VaimoSlider.vue';
import { useDeclination, useLink } from '~/diptyqueTheme/composable';
import type {
  CollectionSliderItemModel,
  CollectionSliderModel
} from '~/diptyqueTheme/types/contentful';

export default defineComponent({
  name: 'CollectionSlider',
  components: {
    VaimoBanner: () => import('atoms/VaimoBanner.vue'),
    VaimoHeading: () => import('atoms/VaimoHeading.vue'),
    VaimoSlider,
    SfLink
  },
  props: {
    sectionData: {
      required: true,
      type: Object as PropType<CollectionSliderModel>
    }
  },
  setup(props) {
    const { normalizeLink } = useLink();
    const { getBannerFunction } = useDeclination(props.sectionData);

    const items = computed(() => {
      const items = props.sectionData?.itemsCollection?.items ?? [];
      return items.filter((item) => !!item?.sys);
    });

    const getItemKey = (item: CollectionSliderItemModel, index: number) =>
      `collection-item-${item.sys.id}-${index}`;

    const hasItems = computed(() => items.value.length > 0);

    return {
      hasItems,
      items,
      getItemKey,
      getBannerFunction,
      normalizeLink
    };
  }
});
